
import Vue from "vue";
import dayjs from "dayjs";
import { NewToiletsApiFunc, NewGatewaysApiFunc, setAccessToken } from "@/api";
import { uploadImage } from "@/api/area";
import { Toilet, Gateway } from "@/models";

import TheTemplate from "../TheNoSidebarTemplate.vue";
import ToiletEditor from "./components/ToiletEditor.vue";
import BaseCloseButton from "@/components/BaseCloseButton.vue";

export type DataType = {
  gateways: Array<Gateway>;
};

export default Vue.extend({
  name: "ToiletCreateScreen",

  components: {
    TheTemplate,
    ToiletEditor,
    BaseCloseButton,
  },

  props: {},

  data(): DataType {
    return {
      gateways: [],
    };
  },

  mounted(): void {
    this.fetchGateways();
  },

  methods: {
    async fetchGateways(): Promise<void> {
      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      // TODO: トイレとまだ紐付いていないものだけにする必要がある？
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewGatewaysApiFunc().listGateways(companyId, undefined, undefined, false);

      if (err != null) {
        this.$handleApiError(err, this.fetchGateways);
        return;
      }

      this.gateways = data.list;
    },

    async createToilet(...toiletAndImage: [Toilet, Blob]): Promise<void> {
      const [toilet, image]: [Toilet, Blob] = toiletAndImage;

      const companyId = this.$auth.companyId;
      if (!companyId) {
        this.$router.replace({ name: "login" });
        return;
      }
      this.$setLoading(true);
      setAccessToken(this.$auth.accessToken);
      const { data, err } = await NewToiletsApiFunc().createToilet(companyId, toilet);

      if (data?.id !== undefined && image !== undefined) {
        const fileName: string = dayjs().format("YYYY-MM-DD HH:mm");
        await uploadImage(companyId, data.id, { file: image, name: fileName });
      }

      this.$setLoading(false);
      this.$setChecked(true);
      this.$afterSuccessRequest(() => {
        this.$router.push({
          name: "company-toilets",
          params: {
            updated: "true",
          },
        });
      }, 2);
    },

    afterLeave(): void {
      this.$setChecked(false);
    },
  },
});
